import { Settings2, Lightbulb, BarChart3, Users } from 'lucide-react';
import { useLanguage } from '../i18n/content';
import { FadeUp, Eyebrow } from './Reveal';

const ICONS = {
  cog: Settings2,
  lightbulb: Lightbulb,
  chart: BarChart3,
  users: Users,
};

export function Principles() {
  const { t } = useLanguage();

  return (
    <section id="prinsip" className="relative overflow-hidden py-16 lg:py-20">
      <div
        aria-hidden
        className="pointer-events-none absolute left-[-12%] top-1/2 h-[520px] w-[520px] -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(229,9,20,0.16),transparent_65%)] blur-2xl"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-10">
        <FadeUp>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <Eyebrow>{t.principles.eyebrow}</Eyebrow>
              <h2
                className="mt-4 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl"
                data-testid="principles-title"
              >
                {t.principles.titleA} {t.principles.titleB}
                <span className="text-nofina-red">.</span>
              </h2>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-slate-400 lg:pb-1 lg:text-right">
              {t.principles.intro}
            </p>
          </div>
        </FadeUp>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:mt-10 lg:grid-cols-4">
          {t.principles.items.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <FadeUp key={item.id} delay={0.06 + i * 0.07} className="h-full">
                <div
                  data-testid={`principle-card-${item.id}`}
                  className="h-full rounded-2xl border border-white/10 bg-white/[0.03] p-5 transition-all duration-500 hover:-translate-y-1 hover:border-nofina-red/40 hover:bg-white/[0.05]"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-nofina-red/30 bg-nofina-red/10 text-nofina-red">
                    <Icon className="h-4 w-4" />
                  </span>
                  <h3 className="mt-4 font-display text-base font-bold text-white">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-400">
                    {item.desc}
                  </p>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
